import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ChatMessage, DbDiagramLayout, DbSchema } from './db-design.models';

export const DbDesignActions = createActionGroup({
  source: 'DbDesign',
  events: {
    Load: emptyProps(),
    'Save Schema': props<{ schema: DbSchema | null }>(),
    'Set Schema Draft': props<{ schema: DbSchema | null }>(),
    'Save Layout': props<{ layout: DbDiagramLayout | null }>(),
    'Set Layout Draft': props<{ layout: DbDiagramLayout | null }>(),
    'Set Chat Messages': props<{ messages: ChatMessage[] }>(),
  },
});
